module.exports = "data:image/gif;base64,R0lGODlhCAAIAIABAP////X19SH5BAEAAAEALAAAAAAIAAgAAAIMjI+JoAGcHjxPzWYKADs="